// Kompresi gambar di sisi browser agar berkas unggahan muat pada batas ukuran.
// Dipakai untuk bukti pembayaran: pengguna cukup memilih foto, sistem yang
// menyesuaikan resolusi dan kualitasnya.

const QUALITIES = [0.85, 0.75, 0.65, 0.55, 0.45];
const LANGKAH_SKALA = 0.75;
const MAKS_LANGKAH_SKALA = 4;

async function muatGambar(file) {
  if (typeof createImageBitmap === "function") {
    try {
      return await createImageBitmap(file);
    } catch {
      // lanjut ke cara lama di bawah
    }
  }
  const url = URL.createObjectURL(file);
  try {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error("Gambar tidak dapat dibaca"));
      img.src = url;
    });
  } finally {
    // Gambar sudah ter-decode saat onload, URL boleh dilepas.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}

function gambarKeBlob(sumber, width, height, quality) {
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, width);
  canvas.height = Math.max(1, height);
  const ctx = canvas.getContext("2d");
  // JPEG tidak mengenal transparansi; beri dasar putih agar area transparan
  // tidak berubah menjadi hitam.
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(sumber, 0, 0, canvas.width, canvas.height);
  return new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
}

function keFile(blob, fileAsli) {
  const nama = (fileAsli.name || "bukti").replace(/\.[^.]+$/, "") + ".jpg";
  return new File([blob], nama, { type: "image/jpeg", lastModified: Date.now() });
}

/**
 * Kecilkan gambar hingga <= maxBytes bila memungkinkan.
 * Berkas non-gambar (mis. PDF) dikembalikan apa adanya.
 */
export async function compressImageFile(file, maxBytes, { maxDimension = 1800 } = {}) {
  if (!file || !file.type?.startsWith("image/")) return file;
  if (file.size <= maxBytes) return file;

  const sumber = await muatGambar(file);
  const lebarAsli = sumber.width;
  const tinggiAsli = sumber.height;
  const skalaAwal = Math.min(1, maxDimension / Math.max(lebarAsli, tinggiAsli));
  let width = Math.round(lebarAsli * skalaAwal);
  let height = Math.round(tinggiAsli * skalaAwal);

  let terakhir = null;
  for (const q of QUALITIES) {
    const blob = await gambarKeBlob(sumber, width, height, q);
    if (!blob) break;
    terakhir = blob;
    if (blob.size <= maxBytes) return keFile(blob, file);
  }

  // Masih terlalu besar: turunkan resolusi bertahap pada kualitas sedang.
  for (let i = 0; i < MAKS_LANGKAH_SKALA; i += 1) {
    width = Math.round(width * LANGKAH_SKALA);
    height = Math.round(height * LANGKAH_SKALA);
    const blob = await gambarKeBlob(sumber, width, height, 0.6);
    if (!blob) break;
    terakhir = blob;
    if (blob.size <= maxBytes) return keFile(blob, file);
  }

  // Kembalikan hasil terkecil yang berhasil dibuat; pemanggil yang memutuskan
  // apakah ukurannya masih dapat diterima.
  return terakhir ? keFile(terakhir, file) : file;
}

export const formatUkuran = (b) => {
  const kb = (b || 0) / 1024;
  return kb >= 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(kb))} KB`;
};
